import React from 'react'
import Text from '../components/Text.js'

import { colors, breakpoints } from '../constants/theme'
const { min1920, min1440, min1024, min768, min480 } = breakpoints

export default props => (
  <Text
    type='linkList'
    {...props}
    hoverColor={colors.highlight}
    lora
    bold
    size={18}
    sizes={{ [ min1920]: 20 }}
    height={44}
    heights={{ [ min768]: 40 }} />
)



// WEBPACK FOOTER //
// ../styleguide/LinkList.js